import { render, staticRenderFns } from "./MobileWalletAmountStat.vue?vue&type=template&id=685373f3&"
import script from "./MobileWalletAmountStat.vue?vue&type=script&lang=js&"
export * from "./MobileWalletAmountStat.vue?vue&type=script&lang=js&"
import style0 from "./MobileWalletAmountStat.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports